import {
  FETCH_INITIAL_DATA_FOR_TLS_ACCOUNT_MODAL,
  FETCH_INITIAL_DATA_FOR_TLS_ACCOUNT_MODAL_SUCCESS,
  FETCH_INITIAL_DATA_FOR_TLS_ACCOUNT_MODAL_FAILURE,
  GENERATE_R2R_CHART,
  GENERATE_R2R_CHART_SUCCESS,
  GENERATE_R2R_CHART_FAILURE,
} from './types';

const initialState = {
  enabledFlagValues: [],
  categoriesWithTags: [],
  categories: [],
  tags: [],
  tlsAccounts: [],
  generatingR2RChart: false,
  isFetchingInitialDataForModal: false,
};

function tlsAccountSettings(state = initialState, action) {
  switch (action.type) {
    case FETCH_INITIAL_DATA_FOR_TLS_ACCOUNT_MODAL:
      return {
        ...state,
        isFetchingInitialDataForModal: true,
      };
    case FETCH_INITIAL_DATA_FOR_TLS_ACCOUNT_MODAL_SUCCESS:
      return {
        ...state,
        enabledFlagValues: action.enabledFlagValues,
        categoriesWithTags: action.categoriesWithTags,
        tags: action.tags,
        tlsAccounts: action.tlsAccounts,
        isFetchingInitialDataForModal: false,
      };
    case FETCH_INITIAL_DATA_FOR_TLS_ACCOUNT_MODAL_FAILURE:
      return {
        ...state,
        isFetchingInitialDataForModal: false,
      };
    case GENERATE_R2R_CHART:
      return {
        ...state,
        generatingR2RChart: true,
      };
    case GENERATE_R2R_CHART_SUCCESS:
    case GENERATE_R2R_CHART_FAILURE:
      return {
        ...state,
        generatingR2RChart: false,
      };
    default:
      return state;
  }
}

export default tlsAccountSettings;
